import React from 'react';
import Cards from '../../components/Product_Index/Cards/Cards';

function WomenPage() {

    return (
        <div>
            <Cards />
        </div>
    );
}

export default WomenPage;